// extracted by mini-css-extract-plugin
export default {"legends":"Legend_legends__jLNSw","legend":"Legend_legend__yOnbq"};